import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  defineProp3hxgpk2knu2px as defineProp,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  Unit_instance14hm69wy3kr8u as Unit_instance,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  Enum3alwj03lh1n41 as Enum,
  IllegalArgumentException_init_$Create$sfel9vrfa7w2 as IllegalArgumentException_init_$Create$,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString30pk9tzaqopn as toString_0,
  Regex_init_$Create$y1ec0tsv67vh as Regex_init_$Create$,
  RegexOption_IGNORE_CASE_getInstance3gy6kkhlhefwp as RegexOption_IGNORE_CASE_getInstance,
  Regex_init_$Create$2bj3lgrxbttcb as Regex_init_$Create$_0,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  LinkedHashMap_init_$Create$2gfxg59gogbfz as LinkedHashMap_init_$Create$,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  LinkedHashMap_init_$Create$snys8oz8txtu as LinkedHashMap_init_$Create$_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance39k978l070lhy as Companion_getInstance,
  LRUCacheb8iduv8rhink as LRUCache,
} from './airtasker-kmp-fundamental-js.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(ClientSideAnalyticsEventFirer, 'ClientSideAnalyticsEventFirer');
initMetadataForInterface(ClientSideFeatureManagement, 'ClientSideFeatureManagement');
initMetadataForInterface(ClientSideFeatureManagementPlatformSpecificConfig, 'ClientSideFeatureManagementPlatformSpecificConfig');
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForClass(DebounceConfig, 'DebounceConfig', DebounceConfig);
initMetadataForClass(ClientSideFeatureManagementConfig, 'ClientSideFeatureManagementConfig');
initMetadataForClass(ClientSideStatsigFeatureManagement, 'ClientSideStatsigFeatureManagement', VOID, VOID, [ClientSideFeatureManagement]);
initMetadataForInterface(ClientSideStatsigSdkWrapper, 'ClientSideStatsigSdkWrapper');
initMetadataForClass(Environment, 'Environment', VOID, Enum);
initMetadataForClass(Experiment, 'Experiment');
initMetadataForClass(ExperimentParameter, 'ExperimentParameter');
initMetadataForClass(ExperimentParameterFetchResult, 'ExperimentParameterFetchResult');
initMetadataForClass(BucketedResult, 'BucketedResult', VOID, ExperimentParameterFetchResult);
initMetadataForClass(UnbucketedResult, 'UnbucketedResult', VOID, ExperimentParameterFetchResult);
function debounceKey() {
  return this.key();
}
initMetadataForInterface(Feature, 'Feature');
initMetadataForClass(SimpleNamedFeature, 'SimpleNamedFeature', VOID, VOID, [Feature]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(CustomIdType, 'CustomIdType', VOID, Enum);
initMetadataForClass(CustomProperty, 'CustomProperty', VOID, Enum);
initMetadataForClass(Platform, 'Platform', VOID, Enum);
initMetadataForClass(User, 'User');
initMetadataForClass(AuthenticatedUser, 'AuthenticatedUser', VOID, User);
initMetadataForClass(AnonymousUser, 'AnonymousUser', VOID, User);
initMetadataForClass(DefaultDebouncerFactory, 'DefaultDebouncerFactory', DefaultDebouncerFactory);
initMetadataForClass(NoOpDebouncer, 'NoOpDebouncer', NoOpDebouncer);
initMetadataForClass(SimpleLRUCacheDebouncer, 'SimpleLRUCacheDebouncer');
initMetadataForInterface(ServerSideFeatureManagementPlatformSpecificConfig, 'ServerSideFeatureManagementPlatformSpecificConfig');
initMetadataForCompanion(Companion_2);
initMetadataForClass(DebounceConfig_0, 'DebounceConfig', DebounceConfig_0);
initMetadataForClass(ServerSideFeatureManagementConfig, 'ServerSideFeatureManagementConfig');
initMetadataForInterface(ServerSideAnalyticsEventFirer, 'ServerSideAnalyticsEventFirer');
initMetadataForInterface(ServerSideFeatureManagement, 'ServerSideFeatureManagement');
initMetadataForClass(ServerSideStatsigFeatureManagement, 'ServerSideStatsigFeatureManagement', VOID, VOID, [ServerSideFeatureManagement]);
initMetadataForInterface(ServerSideStatsigSdkWrapper, 'ServerSideStatsigSdkWrapper');
initMetadataForClass(JsClientSideAnalyticsEventFirerAdapter, 'JsClientSideAnalyticsEventFirerAdapter', VOID, VOID, [ClientSideAnalyticsEventFirer]);
initMetadataForClass(JsClientPlatformSpecificConfig, 'JsClientPlatformSpecificConfig', VOID, VOID, [ClientSideFeatureManagementPlatformSpecificConfig]);
initMetadataForClass(JsServerSideAnalyticsEventFirerAdapter, 'JsServerSideAnalyticsEventFirerAdapter', VOID, VOID, [ServerSideAnalyticsEventFirer]);
initMetadataForClass(JsServerPlatformSpecificConfig, 'JsServerPlatformSpecificConfig', VOID, VOID, [ServerSideFeatureManagementPlatformSpecificConfig]);
initMetadataForClass(JsClientSideStatsigSdkWrapperAdapter, 'JsClientSideStatsigSdkWrapperAdapter', VOID, VOID, [ClientSideStatsigSdkWrapper]);
initMetadataForClass(JsServerSideStatsigSdkWrapperAdapter, 'JsServerSideStatsigSdkWrapperAdapter', VOID, VOID, [ServerSideStatsigSdkWrapper]);
//endregion
function ClientSideAnalyticsEventFirer() {
}
function ClientSideFeatureManagement() {
}
function ClientSideFeatureManagementPlatformSpecificConfig() {
}
function Companion() {
  this.DEFAULT_CACHE_CAPACITY = 10;
  this.DEFAULT_CACHE_TTL_IN_MILLISECONDS = 4000;
}
protoOf(Companion).p8 = function () {
  return this.DEFAULT_CACHE_CAPACITY;
};
protoOf(Companion).q8 = function () {
  return this.DEFAULT_CACHE_TTL_IN_MILLISECONDS;
};
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function Companion_0() {
  Companion_instance_0 = this;
  this.DEFAULT_DEBOUNCE_CONFIG = new DebounceConfig();
}
protoOf(Companion_0).r8 = function () {
  return this.DEFAULT_DEBOUNCE_CONFIG;
};
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 == null)
    new Companion_0();
  return Companion_instance_0;
}
function DebounceConfig(cacheCapacity, cacheTTLInMilliseconds) {
  cacheCapacity = cacheCapacity === VOID ? 10 : cacheCapacity;
  cacheTTLInMilliseconds = cacheTTLInMilliseconds === VOID ? 4000 : cacheTTLInMilliseconds;
  this.cacheCapacity = cacheCapacity;
  this.cacheTTLInMilliseconds = cacheTTLInMilliseconds;
}
protoOf(DebounceConfig).s8 = function () {
  return this.cacheCapacity;
};
protoOf(DebounceConfig).t8 = function () {
  return this.cacheTTLInMilliseconds;
};
protoOf(DebounceConfig).u8 = function () {
  return this.cacheCapacity;
};
protoOf(DebounceConfig).v8 = function () {
  return this.cacheTTLInMilliseconds;
};
protoOf(DebounceConfig).w8 = function (cacheCapacity, cacheTTLInMilliseconds) {
  return new DebounceConfig(cacheCapacity, cacheTTLInMilliseconds);
};
protoOf(DebounceConfig).copy = function (cacheCapacity, cacheTTLInMilliseconds, $super) {
  cacheCapacity = cacheCapacity === VOID ? this.cacheCapacity : cacheCapacity;
  cacheTTLInMilliseconds = cacheTTLInMilliseconds === VOID ? this.cacheTTLInMilliseconds : cacheTTLInMilliseconds;
  return this.w8(cacheCapacity, cacheTTLInMilliseconds);
};
protoOf(DebounceConfig).toString = function () {
  return 'DebounceConfig(cacheCapacity=' + this.cacheCapacity + ', cacheTTLInMilliseconds=' + this.cacheTTLInMilliseconds + ')';
};
protoOf(DebounceConfig).hashCode = function () {
  var result = this.cacheCapacity;
  result = imul(result, 31) + this.cacheTTLInMilliseconds | 0;
  return result;
};
protoOf(DebounceConfig).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DebounceConfig))
    return false;
  var tmp0_other_with_cast = other instanceof DebounceConfig ? other : THROW_CCE();
  if (!(this.cacheCapacity === tmp0_other_with_cast.cacheCapacity))
    return false;
  if (!(this.cacheTTLInMilliseconds === tmp0_other_with_cast.cacheTTLInMilliseconds))
    return false;
  return true;
};
function ClientSideFeatureManagementConfig(user, environment, platformConfig, analyticsEventFirer, experimentDebounceConfig, featureFlagDebounceConfig) {
  Companion_getInstance_1();
  experimentDebounceConfig = experimentDebounceConfig === VOID ? Companion_getInstance_1().DEFAULT_DEBOUNCE_CONFIG : experimentDebounceConfig;
  featureFlagDebounceConfig = featureFlagDebounceConfig === VOID ? Companion_getInstance_1().DEFAULT_DEBOUNCE_CONFIG : featureFlagDebounceConfig;
  this.user = user;
  this.environment = environment;
  this.platformConfig = platformConfig;
  this.analyticsEventFirer = analyticsEventFirer;
  this.experimentDebounceConfig = experimentDebounceConfig;
  this.featureFlagDebounceConfig = featureFlagDebounceConfig;
}
protoOf(ClientSideFeatureManagementConfig).x8 = function () {
  return this.user;
};
protoOf(ClientSideFeatureManagementConfig).y8 = function () {
  return this.environment;
};
protoOf(ClientSideFeatureManagementConfig).z8 = function () {
  return this.platformConfig;
};
protoOf(ClientSideFeatureManagementConfig).a9 = function () {
  return this.analyticsEventFirer;
};
protoOf(ClientSideFeatureManagementConfig).b9 = function () {
  return this.experimentDebounceConfig;
};
protoOf(ClientSideFeatureManagementConfig).c9 = function () {
  return this.featureFlagDebounceConfig;
};
protoOf(ClientSideFeatureManagementConfig).u8 = function () {
  return this.user;
};
protoOf(ClientSideFeatureManagementConfig).v8 = function () {
  return this.environment;
};
protoOf(ClientSideFeatureManagementConfig).d9 = function () {
  return this.platformConfig;
};
protoOf(ClientSideFeatureManagementConfig).e9 = function () {
  return this.analyticsEventFirer;
};
protoOf(ClientSideFeatureManagementConfig).f9 = function () {
  return this.experimentDebounceConfig;
};
protoOf(ClientSideFeatureManagementConfig).g9 = function () {
  return this.featureFlagDebounceConfig;
};
protoOf(ClientSideFeatureManagementConfig).h9 = function (user, environment, platformConfig, analyticsEventFirer, experimentDebounceConfig, featureFlagDebounceConfig) {
  return new ClientSideFeatureManagementConfig(user, environment, platformConfig, analyticsEventFirer, experimentDebounceConfig, featureFlagDebounceConfig);
};
protoOf(ClientSideFeatureManagementConfig).copy = function (user, environment, platformConfig, analyticsEventFirer, experimentDebounceConfig, featureFlagDebounceConfig, $super) {
  user = user === VOID ? this.user : user;
  environment = environment === VOID ? this.environment : environment;
  platformConfig = platformConfig === VOID ? this.platformConfig : platformConfig;
  analyticsEventFirer = analyticsEventFirer === VOID ? this.analyticsEventFirer : analyticsEventFirer;
  experimentDebounceConfig = experimentDebounceConfig === VOID ? this.experimentDebounceConfig : experimentDebounceConfig;
  featureFlagDebounceConfig = featureFlagDebounceConfig === VOID ? this.featureFlagDebounceConfig : featureFlagDebounceConfig;
  return this.h9(user, environment, platformConfig, analyticsEventFirer, experimentDebounceConfig, featureFlagDebounceConfig);
};
protoOf(ClientSideFeatureManagementConfig).toString = function () {
  return 'ClientSideFeatureManagementConfig(user=' + toString(this.user) + ', environment=' + this.environment.toString() + ', platformConfig=' + toString(this.platformConfig) + ', analyticsEventFirer=' + toString(this.analyticsEventFirer) + ', experimentDebounceConfig=' + this.experimentDebounceConfig.toString() + ', featureFlagDebounceConfig=' + this.featureFlagDebounceConfig.toString() + ')';
};
protoOf(ClientSideFeatureManagementConfig).hashCode = function () {
  var result = this.user.hashCode();
  result = imul(result, 31) + this.environment.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.platformConfig) | 0;
  result = imul(result, 31) + hashCode(this.analyticsEventFirer) | 0;
  result = imul(result, 31) + this.experimentDebounceConfig.hashCode() | 0;
  result = imul(result, 31) + this.featureFlagDebounceConfig.hashCode() | 0;
  return result;
};
protoOf(ClientSideFeatureManagementConfig).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClientSideFeatureManagementConfig))
    return false;
  var tmp0_other_with_cast = other instanceof ClientSideFeatureManagementConfig ? other : THROW_CCE();
  if (!this.user.equals(tmp0_other_with_cast.user))
    return false;
  if (!this.environment.equals(tmp0_other_with_cast.environment))
    return false;
  if (!equals(this.platformConfig, tmp0_other_with_cast.platformConfig))
    return false;
  if (!equals(this.analyticsEventFirer, tmp0_other_with_cast.analyticsEventFirer))
    return false;
  if (!this.experimentDebounceConfig.equals(tmp0_other_with_cast.experimentDebounceConfig))
    return false;
  if (!this.featureFlagDebounceConfig.equals(tmp0_other_with_cast.featureFlagDebounceConfig))
    return false;
  return true;
};
function maybeFireExperimentViewedEvent($this, parameter, result) {
  if (result instanceof BucketedResult) {
    $this.k9_1.fireExperimentViewedEvent(parameter.experiment.experimentName, result.variationName);
  } else {
    if (!(result instanceof UnbucketedResult)) {
      noWhenBranchMatchedException();
    }
  }
}
function ClientSideStatsigFeatureManagement$lambda(this$0) {
  return function () {
    this$0.o9_1 = true;
    return Unit_instance;
  };
}
function ClientSideStatsigFeatureManagement$getExperimentParameterBoolean$lambda(this$0, $parameter) {
  return function () {
    var result = this$0.j9_1.getNonLayeredExperimentParameterBoolean($parameter);
    maybeFireExperimentViewedEvent(this$0, $parameter, result);
    return result;
  };
}
function ClientSideStatsigFeatureManagement$getExperimentParameterInteger$lambda(this$0, $parameter) {
  return function () {
    var result = this$0.j9_1.getNonLayeredExperimentParameterInteger($parameter);
    maybeFireExperimentViewedEvent(this$0, $parameter, result);
    return result;
  };
}
function ClientSideStatsigFeatureManagement$getExperimentParameterString$lambda(this$0, $parameter) {
  return function () {
    var result = this$0.j9_1.getNonLayeredExperimentParameterString($parameter);
    maybeFireExperimentViewedEvent(this$0, $parameter, result);
    return result;
  };
}
function ClientSideStatsigFeatureManagement$isFeatureEnabled$lambda(this$0, $feature) {
  return function () {
    return this$0.j9_1.checkGate($feature);
  };
}
function ClientSideStatsigFeatureManagement(config, statsigSdk) {
  this.i9_1 = config;
  this.j9_1 = statsigSdk;
  this.k9_1 = this.i9_1.analyticsEventFirer;
  this.o9_1 = false;
  var debouncerFactory = createPlatformDebouncerFactory();
  this.l9_1 = debouncerFactory.p9(this.i9_1.experimentDebounceConfig.cacheCapacity, this.i9_1.experimentDebounceConfig.cacheTTLInMilliseconds, false);
  this.m9_1 = debouncerFactory.p9(this.i9_1.featureFlagDebounceConfig.cacheCapacity, this.i9_1.featureFlagDebounceConfig.cacheTTLInMilliseconds, false);
  this.i9_1.user.setRequestingPlatform(this.i9_1.platformConfig.platform);
  var tmp = this;
  tmp.n9_1 = this.j9_1.initialise(this.i9_1, ClientSideStatsigFeatureManagement$lambda(this));
}
protoOf(ClientSideStatsigFeatureManagement).getExperimentParameterBoolean = function (parameter) {
  var tmp = this.n9_1;
  var tmp_0 = this.l9_1.q9(tmp, parameter, ClientSideStatsigFeatureManagement$getExperimentParameterBoolean$lambda(this, parameter));
  return tmp_0 instanceof ExperimentParameterFetchResult ? tmp_0 : THROW_CCE();
};
protoOf(ClientSideStatsigFeatureManagement).getExperimentParameterInteger = function (parameter) {
  var tmp = this.n9_1;
  var tmp_0 = this.l9_1.q9(tmp, parameter, ClientSideStatsigFeatureManagement$getExperimentParameterInteger$lambda(this, parameter));
  return tmp_0 instanceof ExperimentParameterFetchResult ? tmp_0 : THROW_CCE();
};
protoOf(ClientSideStatsigFeatureManagement).getExperimentParameterString = function (parameter) {
  var tmp = this.n9_1;
  var tmp_0 = this.l9_1.q9(tmp, parameter, ClientSideStatsigFeatureManagement$getExperimentParameterString$lambda(this, parameter));
  return tmp_0 instanceof ExperimentParameterFetchResult ? tmp_0 : THROW_CCE();
};
protoOf(ClientSideStatsigFeatureManagement).isFeatureEnabled = function (feature) {
  var tmp = this.n9_1;
  return this.m9_1.q9(tmp, feature, ClientSideStatsigFeatureManagement$isFeatureEnabled$lambda(this, feature));
};
protoOf(ClientSideStatsigFeatureManagement).isSdkInitialised = function () {
  return this.o9_1;
};
protoOf(ClientSideStatsigFeatureManagement).setUser = function (user) {
  this.n9_1 = user;
  this.n9_1.setRequestingPlatform(this.i9_1.platformConfig.platform);
  this.j9_1.setUser(user);
};
protoOf(ClientSideStatsigFeatureManagement).shutdown = function () {
  this.j9_1.shutdown();
};
function ClientSideStatsigSdkWrapper() {
}
var Environment_PRODUCTION_instance;
var Environment_DEVELOPMENT_instance;
function values() {
  return [Environment_PRODUCTION_getInstance(), Environment_DEVELOPMENT_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'PRODUCTION':
      return Environment_PRODUCTION_getInstance();
    case 'DEVELOPMENT':
      return Environment_DEVELOPMENT_getInstance();
    default:
      Environment_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var Environment_entriesInitialized;
function Environment_initEntries() {
  if (Environment_entriesInitialized)
    return Unit_instance;
  Environment_entriesInitialized = true;
  Environment_PRODUCTION_instance = new Environment('PRODUCTION', 0);
  Environment_DEVELOPMENT_instance = new Environment('DEVELOPMENT', 1);
}
function Environment(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Environment_PRODUCTION_getInstance() {
  Environment_initEntries();
  return Environment_PRODUCTION_instance;
}
function Environment_DEVELOPMENT_getInstance() {
  Environment_initEntries();
  return Environment_DEVELOPMENT_instance;
}
function Experiment(experimentName) {
  this.experimentName = experimentName;
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.require' call
  if (!(this.experimentName.toLowerCase() === this.experimentName)) {
    // Inline function 'com.airtasker.kmp.feature_management.Experiment.<anonymous>' call
    var message = "Experiment names must be lowercase ('" + this.experimentName + "' is not).";
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(Experiment).t9 = function () {
  return this.experimentName;
};
protoOf(Experiment).u8 = function () {
  return this.experimentName;
};
protoOf(Experiment).u9 = function (experimentName) {
  return new Experiment(experimentName);
};
protoOf(Experiment).copy = function (experimentName, $super) {
  experimentName = experimentName === VOID ? this.experimentName : experimentName;
  return this.u9(experimentName);
};
protoOf(Experiment).toString = function () {
  return 'Experiment(experimentName=' + this.experimentName + ')';
};
protoOf(Experiment).hashCode = function () {
  return getStringHashCode(this.experimentName);
};
protoOf(Experiment).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Experiment))
    return false;
  var tmp0_other_with_cast = other instanceof Experiment ? other : THROW_CCE();
  if (!(this.experimentName === tmp0_other_with_cast.experimentName))
    return false;
  return true;
};
function ExperimentParameter(experiment, parameterName, defaultValue) {
  this.experiment = experiment;
  this.parameterName = parameterName;
  this.defaultValue = defaultValue;
}
protoOf(ExperimentParameter).v9 = function () {
  return this.experiment;
};
protoOf(ExperimentParameter).w9 = function () {
  return this.parameterName;
};
protoOf(ExperimentParameter).x9 = function () {
  return this.defaultValue;
};
protoOf(ExperimentParameter).y9 = function () {
  return this.experiment.experimentName + '|' + this.parameterName;
};
protoOf(ExperimentParameter).u8 = function () {
  return this.experiment;
};
protoOf(ExperimentParameter).v8 = function () {
  return this.parameterName;
};
protoOf(ExperimentParameter).d9 = function () {
  return this.defaultValue;
};
protoOf(ExperimentParameter).z9 = function (experiment, parameterName, defaultValue) {
  return new ExperimentParameter(experiment, parameterName, defaultValue);
};
protoOf(ExperimentParameter).copy = function (experiment, parameterName, defaultValue, $super) {
  experiment = experiment === VOID ? this.experiment : experiment;
  parameterName = parameterName === VOID ? this.parameterName : parameterName;
  defaultValue = defaultValue === VOID ? this.defaultValue : defaultValue;
  return this.z9(experiment, parameterName, defaultValue);
};
protoOf(ExperimentParameter).toString = function () {
  return 'ExperimentParameter(experiment=' + this.experiment.toString() + ', parameterName=' + this.parameterName + ', defaultValue=' + toString_0(this.defaultValue) + ')';
};
protoOf(ExperimentParameter).hashCode = function () {
  var result = this.experiment.hashCode();
  result = imul(result, 31) + getStringHashCode(this.parameterName) | 0;
  result = imul(result, 31) + (this.defaultValue == null ? 0 : hashCode(this.defaultValue)) | 0;
  return result;
};
protoOf(ExperimentParameter).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExperimentParameter))
    return false;
  var tmp0_other_with_cast = other instanceof ExperimentParameter ? other : THROW_CCE();
  if (!this.experiment.equals(tmp0_other_with_cast.experiment))
    return false;
  if (!(this.parameterName === tmp0_other_with_cast.parameterName))
    return false;
  if (!equals(this.defaultValue, tmp0_other_with_cast.defaultValue))
    return false;
  return true;
};
function BucketedResult(result, variationName) {
  ExperimentParameterFetchResult.call(this, result);
  this.variationName = variationName;
}
protoOf(BucketedResult).aa = function () {
  return this.variationName;
};
function UnbucketedResult(result) {
  ExperimentParameterFetchResult.call(this, result);
}
function ExperimentParameterFetchResult(result) {
  this.result = result;
}
protoOf(ExperimentParameterFetchResult).ba = function () {
  return this.result;
};
function Feature() {
}
function SimpleNamedFeature(featureName) {
  this.featureName = featureName;
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.require' call
  if (!(this.featureName.toLowerCase() === this.featureName)) {
    // Inline function 'com.airtasker.kmp.feature_management.SimpleNamedFeature.<anonymous>' call
    var message = "Feature names must be lowercase ('" + this.featureName + "' is not).";
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(SimpleNamedFeature).ca = function () {
  return this.featureName;
};
protoOf(SimpleNamedFeature).key = function () {
  return this.featureName;
};
protoOf(SimpleNamedFeature).u8 = function () {
  return this.featureName;
};
protoOf(SimpleNamedFeature).u9 = function (featureName) {
  return new SimpleNamedFeature(featureName);
};
protoOf(SimpleNamedFeature).copy = function (featureName, $super) {
  featureName = featureName === VOID ? this.featureName : featureName;
  return this.u9(featureName);
};
protoOf(SimpleNamedFeature).toString = function () {
  return 'SimpleNamedFeature(featureName=' + this.featureName + ')';
};
protoOf(SimpleNamedFeature).hashCode = function () {
  return getStringHashCode(this.featureName);
};
protoOf(SimpleNamedFeature).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SimpleNamedFeature))
    return false;
  var tmp0_other_with_cast = other instanceof SimpleNamedFeature ? other : THROW_CCE();
  if (!(this.featureName === tmp0_other_with_cast.featureName))
    return false;
  return true;
};
var CustomIdType_ANONYMOUS_USER_ID_instance;
var CustomIdType_OFFER_ID_instance;
var CustomIdType_POSTER_ID_instance;
var CustomIdType_TASKER_ID_instance;
var CustomIdType_TASK_ULID_instance;
function Companion_1() {
  Companion_instance_1 = this;
  this.da_1 = Regex_init_$Create$('^[0-9]+$');
  this.ea_1 = Regex_init_$Create$_0('^[0-9A-HJKMNP-TV-Z]{26}$', RegexOption_IGNORE_CASE_getInstance());
}
var Companion_instance_1;
function Companion_getInstance_2() {
  CustomIdType_initEntries();
  if (Companion_instance_1 == null)
    new Companion_1();
  return Companion_instance_1;
}
function values_0() {
  return [CustomIdType_ANONYMOUS_USER_ID_getInstance(), CustomIdType_OFFER_ID_getInstance(), CustomIdType_POSTER_ID_getInstance(), CustomIdType_TASKER_ID_getInstance(), CustomIdType_TASK_ULID_getInstance()];
}
function valueOf_0(value) {
  switch (value) {
    case 'ANONYMOUS_USER_ID':
      return CustomIdType_ANONYMOUS_USER_ID_getInstance();
    case 'OFFER_ID':
      return CustomIdType_OFFER_ID_getInstance();
    case 'POSTER_ID':
      return CustomIdType_POSTER_ID_getInstance();
    case 'TASKER_ID':
      return CustomIdType_TASKER_ID_getInstance();
    case 'TASK_ULID':
      return CustomIdType_TASK_ULID_getInstance();
    default:
      CustomIdType_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var CustomIdType_entriesInitialized;
function CustomIdType_initEntries() {
  if (CustomIdType_entriesInitialized)
    return Unit_instance;
  CustomIdType_entriesInitialized = true;
  CustomIdType_ANONYMOUS_USER_ID_instance = new CustomIdType('ANONYMOUS_USER_ID', 0);
  CustomIdType_OFFER_ID_instance = new CustomIdType('OFFER_ID', 1);
  CustomIdType_POSTER_ID_instance = new CustomIdType('POSTER_ID', 2);
  CustomIdType_TASKER_ID_instance = new CustomIdType('TASKER_ID', 3);
  CustomIdType_TASK_ULID_instance = new CustomIdType('TASK_ULID', 4);
  Companion_getInstance_2();
}
function CustomIdType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
protoOf(CustomIdType).validateValue = function (value) {
  // Inline function 'kotlin.text.isNotEmpty' call
  // Inline function 'kotlin.require' call
  if (!(charSequenceLength(value) > 0)) {
    // Inline function 'com.airtasker.kmp.feature_management.CustomIdType.validateValue.<anonymous>' call
    var message = 'Custom ID value must not be empty';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  switch (this.c1_1) {
    case 0:
      break;
    case 1:
      // Inline function 'kotlin.require' call

      if (!Companion_getInstance_2().da_1.n6(value)) {
        // Inline function 'com.airtasker.kmp.feature_management.CustomIdType.validateValue.<anonymous>' call
        var message_0 = 'OFFER_ID values must be an integer offer ID';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }

      break;
    case 2:
      // Inline function 'kotlin.require' call

      if (!Companion_getInstance_2().da_1.n6(value)) {
        // Inline function 'com.airtasker.kmp.feature_management.CustomIdType.validateValue.<anonymous>' call
        var message_1 = 'POSTER_ID values must be an integer user ID';
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }

      break;
    case 3:
      // Inline function 'kotlin.require' call

      if (!Companion_getInstance_2().da_1.n6(value)) {
        // Inline function 'com.airtasker.kmp.feature_management.CustomIdType.validateValue.<anonymous>' call
        var message_2 = 'TASKER_ID values must be an integer user ID';
        throw IllegalArgumentException_init_$Create$(toString(message_2));
      }

      break;
    case 4:
      // Inline function 'kotlin.require' call

      if (!Companion_getInstance_2().ea_1.n6(value)) {
        // Inline function 'com.airtasker.kmp.feature_management.CustomIdType.validateValue.<anonymous>' call
        var message_3 = 'TASK_ULID values must be a valid ULID';
        throw IllegalArgumentException_init_$Create$(toString(message_3));
      }

      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
};
var CustomProperty_REQUESTING_PLATFORM_instance;
var CustomProperty_AIRTASKER_REGION_CODE_instance;
function values_1() {
  return [CustomProperty_REQUESTING_PLATFORM_getInstance(), CustomProperty_AIRTASKER_REGION_CODE_getInstance()];
}
function valueOf_1(value) {
  switch (value) {
    case 'REQUESTING_PLATFORM':
      return CustomProperty_REQUESTING_PLATFORM_getInstance();
    case 'AIRTASKER_REGION_CODE':
      return CustomProperty_AIRTASKER_REGION_CODE_getInstance();
    default:
      CustomProperty_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var CustomProperty_entriesInitialized;
function CustomProperty_initEntries() {
  if (CustomProperty_entriesInitialized)
    return Unit_instance;
  CustomProperty_entriesInitialized = true;
  CustomProperty_REQUESTING_PLATFORM_instance = new CustomProperty('REQUESTING_PLATFORM', 0);
  CustomProperty_AIRTASKER_REGION_CODE_instance = new CustomProperty('AIRTASKER_REGION_CODE', 1);
}
function CustomProperty(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var Platform_ANDROID_instance;
var Platform_BACKEND_instance;
var Platform_IOS_instance;
var Platform_WEB_instance;
function values_2() {
  return [Platform_ANDROID_getInstance(), Platform_BACKEND_getInstance(), Platform_IOS_getInstance(), Platform_WEB_getInstance()];
}
function valueOf_2(value) {
  switch (value) {
    case 'ANDROID':
      return Platform_ANDROID_getInstance();
    case 'BACKEND':
      return Platform_BACKEND_getInstance();
    case 'IOS':
      return Platform_IOS_getInstance();
    case 'WEB':
      return Platform_WEB_getInstance();
    default:
      Platform_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var Platform_entriesInitialized;
function Platform_initEntries() {
  if (Platform_entriesInitialized)
    return Unit_instance;
  Platform_entriesInitialized = true;
  Platform_ANDROID_instance = new Platform('ANDROID', 0, 'android');
  Platform_BACKEND_instance = new Platform('BACKEND', 1, 'backend');
  Platform_IOS_instance = new Platform('IOS', 2, 'ios');
  Platform_WEB_instance = new Platform('WEB', 3, 'web');
}
function Platform(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.value = value;
}
protoOf(Platform).q = function () {
  return this.value;
};
function User(userId, airtaskerRegionCode) {
  this.userId = userId;
  this.airtaskerRegionCode = airtaskerRegionCode;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.customIds = LinkedHashMap_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp_0.customProperties = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = this.userId;
  // Inline function 'kotlin.require' call
  if (!(charSequenceLength(this_0) > 0)) {
    // Inline function 'com.airtasker.kmp.feature_management.User.<anonymous>' call
    var message = 'User ID must not be empty';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_1 = this.airtaskerRegionCode;
  // Inline function 'kotlin.require' call
  if (!(charSequenceLength(this_1) > 0)) {
    // Inline function 'com.airtasker.kmp.feature_management.User.<anonymous>' call
    var message_0 = 'Airtasker region code must not be empty';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  this.setCustomProperty(CustomProperty_AIRTASKER_REGION_CODE_getInstance(), this.airtaskerRegionCode);
  this.statsigCountryCode = Companion_getInstance().fromAirtaskerRegionCode(this.airtaskerRegionCode).isoAlpha2CountryCode;
  this.statsigUserId = this.userId;
}
protoOf(User).la = function () {
  return this.userId;
};
protoOf(User).w7 = function () {
  return this.airtaskerRegionCode;
};
protoOf(User).ma = function () {
  return this.customIds;
};
protoOf(User).na = function () {
  return this.customProperties;
};
protoOf(User).oa = function () {
  return this.statsigCountryCode;
};
protoOf(User).pa = function () {
  return this.statsigUserId;
};
protoOf(User).setCustomId = function (idType, value) {
  idType.validateValue(value);
  // Inline function 'kotlin.collections.set' call
  this.customIds.x(idType, value);
};
protoOf(User).setCustomProperty = function (property, value) {
  // Inline function 'kotlin.collections.set' call
  this.customProperties.x(property, value);
};
protoOf(User).setRequestingPlatform = function (platform) {
  var tmp0 = this.customProperties;
  var tmp1 = CustomProperty_REQUESTING_PLATFORM_getInstance();
  // Inline function 'kotlin.collections.set' call
  var value = platform.value;
  tmp0.x(tmp1, value);
};
protoOf(User).equals = function (other) {
  var tmp;
  if (other instanceof User) {
    tmp = (this.userId === other.userId && this.airtaskerRegionCode === other.airtaskerRegionCode && equals(this.customIds, other.customIds) && equals(this.customProperties, other.customProperties));
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(User).hashCode = function () {
  return getStringHashCode(this.userId) ^ getStringHashCode(this.airtaskerRegionCode) ^ hashCode(this.customIds) ^ hashCode(this.customProperties);
};
function AuthenticatedUser(airtaskerUserId, airtaskerRegionCode) {
  User.call(this, airtaskerUserId, airtaskerRegionCode);
}
function AnonymousUser(anonymousUserId, airtaskerRegionCode) {
  User.call(this, anonymousUserId, airtaskerRegionCode);
  this.setCustomId(CustomIdType_ANONYMOUS_USER_ID_getInstance(), anonymousUserId);
}
function CustomIdType_ANONYMOUS_USER_ID_getInstance() {
  CustomIdType_initEntries();
  return CustomIdType_ANONYMOUS_USER_ID_instance;
}
function CustomIdType_OFFER_ID_getInstance() {
  CustomIdType_initEntries();
  return CustomIdType_OFFER_ID_instance;
}
function CustomIdType_POSTER_ID_getInstance() {
  CustomIdType_initEntries();
  return CustomIdType_POSTER_ID_instance;
}
function CustomIdType_TASKER_ID_getInstance() {
  CustomIdType_initEntries();
  return CustomIdType_TASKER_ID_instance;
}
function CustomIdType_TASK_ULID_getInstance() {
  CustomIdType_initEntries();
  return CustomIdType_TASK_ULID_instance;
}
function CustomProperty_REQUESTING_PLATFORM_getInstance() {
  CustomProperty_initEntries();
  return CustomProperty_REQUESTING_PLATFORM_instance;
}
function CustomProperty_AIRTASKER_REGION_CODE_getInstance() {
  CustomProperty_initEntries();
  return CustomProperty_AIRTASKER_REGION_CODE_instance;
}
function Platform_ANDROID_getInstance() {
  Platform_initEntries();
  return Platform_ANDROID_instance;
}
function Platform_BACKEND_getInstance() {
  Platform_initEntries();
  return Platform_BACKEND_instance;
}
function Platform_IOS_getInstance() {
  Platform_initEntries();
  return Platform_IOS_instance;
}
function Platform_WEB_getInstance() {
  Platform_initEntries();
  return Platform_WEB_instance;
}
function isCachingDisabled($this, cacheCapacity) {
  return cacheCapacity <= 0;
}
function DefaultDebouncerFactory() {
}
protoOf(DefaultDebouncerFactory).p9 = function (cacheCapacity, cacheTTLInMilliseconds, isThreadSafe) {
  var tmp;
  if (isCachingDisabled(this, cacheCapacity)) {
    tmp = new NoOpDebouncer();
  } else {
    tmp = new SimpleLRUCacheDebouncer(cacheCapacity, cacheTTLInMilliseconds);
  }
  return tmp;
};
function NoOpDebouncer() {
}
protoOf(NoOpDebouncer).q9 = function (user, target, block) {
  return block();
};
function buildCacheKey($this, user, target) {
  return '' + user.hashCode() + '|' + target.y9();
}
function SimpleLRUCacheDebouncer(cacheCapacity, cacheTTLInMilliseconds) {
  this.qa_1 = new LRUCache(cacheCapacity, cacheTTLInMilliseconds);
}
protoOf(SimpleLRUCacheDebouncer).q9 = function (user, target, block) {
  var cacheKey = buildCacheKey(this, user, target);
  var cachedValue = this.qa_1.m8(cacheKey);
  if (!(cachedValue == null)) {
    return cachedValue;
  }
  var newValue = block();
  this.qa_1.n8(cacheKey, newValue);
  return newValue;
};
function get_STATSIG_ANONYMOUS_EMAIL_ADDRESS() {
  return STATSIG_ANONYMOUS_EMAIL_ADDRESS_0;
}
var STATSIG_ANONYMOUS_EMAIL_ADDRESS_0;
function get_STATSIG_ANONYMOUS_IP_ADDRESS() {
  return STATSIG_ANONYMOUS_IP_ADDRESS_0;
}
var STATSIG_ANONYMOUS_IP_ADDRESS_0;
function toStatsigTierName(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.c1_1) {
    case 0:
      tmp = 'production';
      break;
    case 1:
      tmp = 'development';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function getStatsigCustomProperties(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mapKeys' call
  var this_0 = _this__u8e3s4.customProperties;
  // Inline function 'kotlin.collections.mapKeysTo' call
  var destination = LinkedHashMap_init_$Create$_0(mapCapacity(this_0.h()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_0.w().e();
  while (_iterator__ex2g4s.f()) {
    var element = _iterator__ex2g4s.g();
    // Inline function 'com.airtasker.kmp.feature_management.statsig.getStatsigCustomProperties.<anonymous>' call
    var tmp = toStatsigCustomPropertyName(element.p());
    // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
    var tmp$ret$1 = element.q();
    destination.x(tmp, tmp$ret$1);
  }
  return destination;
}
function getStatsigCustomUnitIds(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mapKeys' call
  var this_0 = _this__u8e3s4.customIds;
  // Inline function 'kotlin.collections.mapKeysTo' call
  var destination = LinkedHashMap_init_$Create$_0(mapCapacity(this_0.h()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_0.w().e();
  while (_iterator__ex2g4s.f()) {
    var element = _iterator__ex2g4s.g();
    // Inline function 'com.airtasker.kmp.feature_management.statsig.getStatsigCustomUnitIds.<anonymous>' call
    var tmp = toStatsigCustomUnitIdName(element.p());
    // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
    var tmp$ret$1 = element.q();
    destination.x(tmp, tmp$ret$1);
  }
  return destination;
}
function toStatsigCustomUnitIdName(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.c1_1) {
    case 0:
      tmp = 'Anonymous ID';
      break;
    case 1:
      tmp = 'Offer ID';
      break;
    case 2:
      tmp = 'Poster ID';
      break;
    case 3:
      tmp = 'Tasker ID';
      break;
    case 4:
      tmp = 'Task ULID';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toStatsigCustomPropertyName(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.c1_1) {
    case 1:
      tmp = 'region_code';
      break;
    case 0:
      tmp = 'platform';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function ServerSideFeatureManagementPlatformSpecificConfig() {
}
function Companion_2() {
  this.DEFAULT_CACHE_CAPACITY = 4096;
  this.DEFAULT_CACHE_TTL_IN_MILLISECONDS = 4000;
  this.DEFAULT_IS_THREAD_SAFE = true;
}
protoOf(Companion_2).p8 = function () {
  return this.DEFAULT_CACHE_CAPACITY;
};
protoOf(Companion_2).q8 = function () {
  return this.DEFAULT_CACHE_TTL_IN_MILLISECONDS;
};
protoOf(Companion_2).ra = function () {
  return this.DEFAULT_IS_THREAD_SAFE;
};
var Companion_instance_2;
function Companion_getInstance_3() {
  return Companion_instance_2;
}
function DebounceConfig_0(cacheCapacity, cacheTTLInMilliseconds, isThreadSafe) {
  cacheCapacity = cacheCapacity === VOID ? 4096 : cacheCapacity;
  cacheTTLInMilliseconds = cacheTTLInMilliseconds === VOID ? 4000 : cacheTTLInMilliseconds;
  isThreadSafe = isThreadSafe === VOID ? true : isThreadSafe;
  this.cacheCapacity = cacheCapacity;
  this.cacheTTLInMilliseconds = cacheTTLInMilliseconds;
  this.isThreadSafe = isThreadSafe;
}
protoOf(DebounceConfig_0).s8 = function () {
  return this.cacheCapacity;
};
protoOf(DebounceConfig_0).t8 = function () {
  return this.cacheTTLInMilliseconds;
};
protoOf(DebounceConfig_0).sa = function () {
  return this.isThreadSafe;
};
protoOf(DebounceConfig_0).u8 = function () {
  return this.cacheCapacity;
};
protoOf(DebounceConfig_0).v8 = function () {
  return this.cacheTTLInMilliseconds;
};
protoOf(DebounceConfig_0).d9 = function () {
  return this.isThreadSafe;
};
protoOf(DebounceConfig_0).ta = function (cacheCapacity, cacheTTLInMilliseconds, isThreadSafe) {
  return new DebounceConfig_0(cacheCapacity, cacheTTLInMilliseconds, isThreadSafe);
};
protoOf(DebounceConfig_0).copy = function (cacheCapacity, cacheTTLInMilliseconds, isThreadSafe, $super) {
  cacheCapacity = cacheCapacity === VOID ? this.cacheCapacity : cacheCapacity;
  cacheTTLInMilliseconds = cacheTTLInMilliseconds === VOID ? this.cacheTTLInMilliseconds : cacheTTLInMilliseconds;
  isThreadSafe = isThreadSafe === VOID ? this.isThreadSafe : isThreadSafe;
  return this.ta(cacheCapacity, cacheTTLInMilliseconds, isThreadSafe);
};
protoOf(DebounceConfig_0).toString = function () {
  return 'DebounceConfig(cacheCapacity=' + this.cacheCapacity + ', cacheTTLInMilliseconds=' + this.cacheTTLInMilliseconds + ', isThreadSafe=' + this.isThreadSafe + ')';
};
protoOf(DebounceConfig_0).hashCode = function () {
  var result = this.cacheCapacity;
  result = imul(result, 31) + this.cacheTTLInMilliseconds | 0;
  result = imul(result, 31) + getBooleanHashCode(this.isThreadSafe) | 0;
  return result;
};
protoOf(DebounceConfig_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DebounceConfig_0))
    return false;
  var tmp0_other_with_cast = other instanceof DebounceConfig_0 ? other : THROW_CCE();
  if (!(this.cacheCapacity === tmp0_other_with_cast.cacheCapacity))
    return false;
  if (!(this.cacheTTLInMilliseconds === tmp0_other_with_cast.cacheTTLInMilliseconds))
    return false;
  if (!(this.isThreadSafe === tmp0_other_with_cast.isThreadSafe))
    return false;
  return true;
};
function ServerSideFeatureManagementConfig(environment, platformConfig, analyticsEventFirer, experimentDebounceConfig, featureFlagDebounceConfig) {
  experimentDebounceConfig = experimentDebounceConfig === VOID ? new DebounceConfig_0() : experimentDebounceConfig;
  featureFlagDebounceConfig = featureFlagDebounceConfig === VOID ? new DebounceConfig_0() : featureFlagDebounceConfig;
  this.environment = environment;
  this.platformConfig = platformConfig;
  this.analyticsEventFirer = analyticsEventFirer;
  this.experimentDebounceConfig = experimentDebounceConfig;
  this.featureFlagDebounceConfig = featureFlagDebounceConfig;
}
protoOf(ServerSideFeatureManagementConfig).y8 = function () {
  return this.environment;
};
protoOf(ServerSideFeatureManagementConfig).z8 = function () {
  return this.platformConfig;
};
protoOf(ServerSideFeatureManagementConfig).a9 = function () {
  return this.analyticsEventFirer;
};
protoOf(ServerSideFeatureManagementConfig).b9 = function () {
  return this.experimentDebounceConfig;
};
protoOf(ServerSideFeatureManagementConfig).c9 = function () {
  return this.featureFlagDebounceConfig;
};
protoOf(ServerSideFeatureManagementConfig).u8 = function () {
  return this.environment;
};
protoOf(ServerSideFeatureManagementConfig).v8 = function () {
  return this.platformConfig;
};
protoOf(ServerSideFeatureManagementConfig).d9 = function () {
  return this.analyticsEventFirer;
};
protoOf(ServerSideFeatureManagementConfig).e9 = function () {
  return this.experimentDebounceConfig;
};
protoOf(ServerSideFeatureManagementConfig).f9 = function () {
  return this.featureFlagDebounceConfig;
};
protoOf(ServerSideFeatureManagementConfig).ua = function (environment, platformConfig, analyticsEventFirer, experimentDebounceConfig, featureFlagDebounceConfig) {
  return new ServerSideFeatureManagementConfig(environment, platformConfig, analyticsEventFirer, experimentDebounceConfig, featureFlagDebounceConfig);
};
protoOf(ServerSideFeatureManagementConfig).copy = function (environment, platformConfig, analyticsEventFirer, experimentDebounceConfig, featureFlagDebounceConfig, $super) {
  environment = environment === VOID ? this.environment : environment;
  platformConfig = platformConfig === VOID ? this.platformConfig : platformConfig;
  analyticsEventFirer = analyticsEventFirer === VOID ? this.analyticsEventFirer : analyticsEventFirer;
  experimentDebounceConfig = experimentDebounceConfig === VOID ? this.experimentDebounceConfig : experimentDebounceConfig;
  featureFlagDebounceConfig = featureFlagDebounceConfig === VOID ? this.featureFlagDebounceConfig : featureFlagDebounceConfig;
  return this.ua(environment, platformConfig, analyticsEventFirer, experimentDebounceConfig, featureFlagDebounceConfig);
};
protoOf(ServerSideFeatureManagementConfig).toString = function () {
  return 'ServerSideFeatureManagementConfig(environment=' + this.environment.toString() + ', platformConfig=' + toString(this.platformConfig) + ', analyticsEventFirer=' + toString(this.analyticsEventFirer) + ', experimentDebounceConfig=' + this.experimentDebounceConfig.toString() + ', featureFlagDebounceConfig=' + this.featureFlagDebounceConfig.toString() + ')';
};
protoOf(ServerSideFeatureManagementConfig).hashCode = function () {
  var result = this.environment.hashCode();
  result = imul(result, 31) + hashCode(this.platformConfig) | 0;
  result = imul(result, 31) + hashCode(this.analyticsEventFirer) | 0;
  result = imul(result, 31) + this.experimentDebounceConfig.hashCode() | 0;
  result = imul(result, 31) + this.featureFlagDebounceConfig.hashCode() | 0;
  return result;
};
protoOf(ServerSideFeatureManagementConfig).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ServerSideFeatureManagementConfig))
    return false;
  var tmp0_other_with_cast = other instanceof ServerSideFeatureManagementConfig ? other : THROW_CCE();
  if (!this.environment.equals(tmp0_other_with_cast.environment))
    return false;
  if (!equals(this.platformConfig, tmp0_other_with_cast.platformConfig))
    return false;
  if (!equals(this.analyticsEventFirer, tmp0_other_with_cast.analyticsEventFirer))
    return false;
  if (!this.experimentDebounceConfig.equals(tmp0_other_with_cast.experimentDebounceConfig))
    return false;
  if (!this.featureFlagDebounceConfig.equals(tmp0_other_with_cast.featureFlagDebounceConfig))
    return false;
  return true;
};
function ServerSideAnalyticsEventFirer() {
}
function ServerSideFeatureManagement() {
}
function maybeFireExperimentViewedEvent_0($this, user, parameter, result) {
  if (result instanceof BucketedResult) {
    $this.xa_1.fireExperimentViewedEvent(user, parameter.experiment.experimentName, result.variationName);
  } else {
    if (!(result instanceof UnbucketedResult)) {
      noWhenBranchMatchedException();
    }
  }
}
function ServerSideStatsigFeatureManagement$getExperimentParameterBoolean$lambda(this$0, $parameter, $user) {
  return function () {
    var result = this$0.wa_1.getNonLayeredExperimentParameterBoolean($parameter, $user);
    maybeFireExperimentViewedEvent_0(this$0, $user, $parameter, result);
    return result;
  };
}
function ServerSideStatsigFeatureManagement$getExperimentParameterInteger$lambda(this$0, $parameter, $user) {
  return function () {
    var result = this$0.wa_1.getNonLayeredExperimentParameterInteger($parameter, $user);
    maybeFireExperimentViewedEvent_0(this$0, $user, $parameter, result);
    return result;
  };
}
function ServerSideStatsigFeatureManagement$getExperimentParameterString$lambda(this$0, $parameter, $user) {
  return function () {
    var result = this$0.wa_1.getNonLayeredExperimentParameterString($parameter, $user);
    maybeFireExperimentViewedEvent_0(this$0, $user, $parameter, result);
    return result;
  };
}
function ServerSideStatsigFeatureManagement$isFeatureEnabled$lambda(this$0, $feature, $user) {
  return function () {
    return this$0.wa_1.checkGate($feature, $user);
  };
}
function ServerSideStatsigFeatureManagement(config, statsigSdk) {
  this.va_1 = config;
  this.wa_1 = statsigSdk;
  this.xa_1 = this.va_1.analyticsEventFirer;
  var debouncerFactory = createPlatformDebouncerFactory();
  this.ya_1 = debouncerFactory.p9(this.va_1.experimentDebounceConfig.cacheCapacity, this.va_1.experimentDebounceConfig.cacheTTLInMilliseconds, this.va_1.experimentDebounceConfig.isThreadSafe);
  this.za_1 = debouncerFactory.p9(this.va_1.featureFlagDebounceConfig.cacheCapacity, this.va_1.featureFlagDebounceConfig.cacheTTLInMilliseconds, this.va_1.experimentDebounceConfig.isThreadSafe);
  this.wa_1.initialise(this.va_1);
}
protoOf(ServerSideStatsigFeatureManagement).getExperimentParameterBoolean = function (parameter, user) {
  var tmp = this.ya_1.q9(user, parameter, ServerSideStatsigFeatureManagement$getExperimentParameterBoolean$lambda(this, parameter, user));
  return tmp instanceof ExperimentParameterFetchResult ? tmp : THROW_CCE();
};
protoOf(ServerSideStatsigFeatureManagement).getExperimentParameterInteger = function (parameter, user) {
  var tmp = this.ya_1.q9(user, parameter, ServerSideStatsigFeatureManagement$getExperimentParameterInteger$lambda(this, parameter, user));
  return tmp instanceof ExperimentParameterFetchResult ? tmp : THROW_CCE();
};
protoOf(ServerSideStatsigFeatureManagement).getExperimentParameterString = function (parameter, user) {
  var tmp = this.ya_1.q9(user, parameter, ServerSideStatsigFeatureManagement$getExperimentParameterString$lambda(this, parameter, user));
  return tmp instanceof ExperimentParameterFetchResult ? tmp : THROW_CCE();
};
protoOf(ServerSideStatsigFeatureManagement).isFeatureEnabled = function (feature, user) {
  user.setRequestingPlatform(this.va_1.platformConfig.platform);
  return this.za_1.q9(user, feature, ServerSideStatsigFeatureManagement$isFeatureEnabled$lambda(this, feature, user));
};
protoOf(ServerSideStatsigFeatureManagement).shutdown = function () {
  this.wa_1.shutdown();
};
function ServerSideStatsigSdkWrapper() {
}
function JsClientSideAnalyticsEventFirerAdapter(jsAnalyticsEventFirer) {
  this.ab_1 = jsAnalyticsEventFirer;
}
protoOf(JsClientSideAnalyticsEventFirerAdapter).fireExperimentViewedEvent = function (experimentId, variationId) {
  this.ab_1.fireExperimentViewedEvent(experimentId, variationId);
};
function JsClientPlatformSpecificConfig(statsigSdkWrapper) {
  this.statsigSdkWrapper = statsigSdkWrapper;
  this.bb_1 = Platform_WEB_getInstance();
}
protoOf(JsClientPlatformSpecificConfig).cb = function () {
  return this.statsigSdkWrapper;
};
protoOf(JsClientPlatformSpecificConfig).o8 = function () {
  return this.bb_1;
};
protoOf(JsClientPlatformSpecificConfig).u8 = function () {
  return this.statsigSdkWrapper;
};
protoOf(JsClientPlatformSpecificConfig).db = function (statsigSdkWrapper) {
  return new JsClientPlatformSpecificConfig(statsigSdkWrapper);
};
protoOf(JsClientPlatformSpecificConfig).copy = function (statsigSdkWrapper, $super) {
  statsigSdkWrapper = statsigSdkWrapper === VOID ? this.statsigSdkWrapper : statsigSdkWrapper;
  return this.db(statsigSdkWrapper);
};
protoOf(JsClientPlatformSpecificConfig).toString = function () {
  return 'JsClientPlatformSpecificConfig(statsigSdkWrapper=' + toString(this.statsigSdkWrapper) + ')';
};
protoOf(JsClientPlatformSpecificConfig).hashCode = function () {
  return hashCode(this.statsigSdkWrapper);
};
protoOf(JsClientPlatformSpecificConfig).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof JsClientPlatformSpecificConfig))
    return false;
  var tmp0_other_with_cast = other instanceof JsClientPlatformSpecificConfig ? other : THROW_CCE();
  if (!equals(this.statsigSdkWrapper, tmp0_other_with_cast.statsigSdkWrapper))
    return false;
  return true;
};
function getClientSidePlatformFeatureManagement(config) {
  var tmp = config.platformConfig;
  var platformSpecificConfig = tmp instanceof JsClientPlatformSpecificConfig ? tmp : THROW_CCE();
  return new ClientSideStatsigFeatureManagement(config, platformSpecificConfig.statsigSdkWrapper);
}
function createPlatformDebouncerFactory() {
  return new DefaultDebouncerFactory();
}
function JsServerSideAnalyticsEventFirerAdapter(jsAnalyticsEventFirer) {
  this.eb_1 = jsAnalyticsEventFirer;
}
protoOf(JsServerSideAnalyticsEventFirerAdapter).fireExperimentViewedEvent = function (user, experimentId, variationId) {
  this.eb_1.fireExperimentViewedEvent(user, experimentId, variationId);
};
function JsServerPlatformSpecificConfig(statsigSdkWrapper) {
  this.statsigSdkWrapper = statsigSdkWrapper;
  this.fb_1 = Platform_WEB_getInstance();
}
protoOf(JsServerPlatformSpecificConfig).cb = function () {
  return this.statsigSdkWrapper;
};
protoOf(JsServerPlatformSpecificConfig).o8 = function () {
  return this.fb_1;
};
protoOf(JsServerPlatformSpecificConfig).u8 = function () {
  return this.statsigSdkWrapper;
};
protoOf(JsServerPlatformSpecificConfig).gb = function (statsigSdkWrapper) {
  return new JsServerPlatformSpecificConfig(statsigSdkWrapper);
};
protoOf(JsServerPlatformSpecificConfig).copy = function (statsigSdkWrapper, $super) {
  statsigSdkWrapper = statsigSdkWrapper === VOID ? this.statsigSdkWrapper : statsigSdkWrapper;
  return this.gb(statsigSdkWrapper);
};
protoOf(JsServerPlatformSpecificConfig).toString = function () {
  return 'JsServerPlatformSpecificConfig(statsigSdkWrapper=' + toString(this.statsigSdkWrapper) + ')';
};
protoOf(JsServerPlatformSpecificConfig).hashCode = function () {
  return hashCode(this.statsigSdkWrapper);
};
protoOf(JsServerPlatformSpecificConfig).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof JsServerPlatformSpecificConfig))
    return false;
  var tmp0_other_with_cast = other instanceof JsServerPlatformSpecificConfig ? other : THROW_CCE();
  if (!equals(this.statsigSdkWrapper, tmp0_other_with_cast.statsigSdkWrapper))
    return false;
  return true;
};
function getServerSidePlatformFeatureManagement(config) {
  var tmp = config.platformConfig;
  var platformSpecificConfig = tmp instanceof JsServerPlatformSpecificConfig ? tmp : THROW_CCE();
  return new ServerSideStatsigFeatureManagement(config, platformSpecificConfig.statsigSdkWrapper);
}
function JsClientSideStatsigSdkWrapperAdapter(wrapper) {
  this.hb_1 = wrapper;
}
protoOf(JsClientSideStatsigSdkWrapperAdapter).initialise = function (config, onSdkInitialised) {
  return this.hb_1.initialise(config, onSdkInitialised);
};
protoOf(JsClientSideStatsigSdkWrapperAdapter).checkGate = function (feature) {
  return this.hb_1.checkGate(feature);
};
protoOf(JsClientSideStatsigSdkWrapperAdapter).getNonLayeredExperimentParameterBoolean = function (parameter) {
  return this.hb_1.getNonLayeredExperimentParameterBoolean(parameter);
};
protoOf(JsClientSideStatsigSdkWrapperAdapter).getNonLayeredExperimentParameterInteger = function (parameter) {
  return this.hb_1.getNonLayeredExperimentParameterInteger(parameter);
};
protoOf(JsClientSideStatsigSdkWrapperAdapter).getNonLayeredExperimentParameterString = function (parameter) {
  return this.hb_1.getNonLayeredExperimentParameterString(parameter);
};
protoOf(JsClientSideStatsigSdkWrapperAdapter).setUser = function (user) {
  this.hb_1.setUser(user);
};
protoOf(JsClientSideStatsigSdkWrapperAdapter).shutdown = function () {
  this.hb_1.shutdown();
};
function JsServerSideStatsigSdkWrapperAdapter(wrapper) {
  this.ib_1 = wrapper;
}
protoOf(JsServerSideStatsigSdkWrapperAdapter).initialise = function (config) {
  this.ib_1.initialise(config);
};
protoOf(JsServerSideStatsigSdkWrapperAdapter).checkGate = function (feature, user) {
  return this.ib_1.checkGate(feature, user);
};
protoOf(JsServerSideStatsigSdkWrapperAdapter).getNonLayeredExperimentParameterBoolean = function (parameter, user) {
  return this.ib_1.getNonLayeredExperimentParameterBoolean(parameter, user);
};
protoOf(JsServerSideStatsigSdkWrapperAdapter).getNonLayeredExperimentParameterInteger = function (parameter, user) {
  return this.ib_1.getNonLayeredExperimentParameterInteger(parameter, user);
};
protoOf(JsServerSideStatsigSdkWrapperAdapter).getNonLayeredExperimentParameterString = function (parameter, user) {
  return this.ib_1.getNonLayeredExperimentParameterString(parameter, user);
};
protoOf(JsServerSideStatsigSdkWrapperAdapter).shutdown = function () {
  this.ib_1.shutdown();
};
//region block: post-declaration
defineProp(protoOf(Environment), 'name', protoOf(Environment).d1);
defineProp(protoOf(Environment), 'ordinal', protoOf(Environment).e1);
protoOf(SimpleNamedFeature).y9 = debounceKey;
defineProp(protoOf(CustomIdType), 'name', protoOf(CustomIdType).d1);
defineProp(protoOf(CustomIdType), 'ordinal', protoOf(CustomIdType).e1);
defineProp(protoOf(CustomProperty), 'name', protoOf(CustomProperty).d1);
defineProp(protoOf(CustomProperty), 'ordinal', protoOf(CustomProperty).e1);
defineProp(protoOf(Platform), 'name', protoOf(Platform).d1);
defineProp(protoOf(Platform), 'ordinal', protoOf(Platform).e1);
defineProp(protoOf(JsClientPlatformSpecificConfig), 'platform', function () {
  return this.o8();
});
defineProp(protoOf(JsServerPlatformSpecificConfig), 'platform', function () {
  return this.o8();
});
//endregion
//region block: init
Companion_instance = new Companion();
STATSIG_ANONYMOUS_EMAIL_ADDRESS_0 = null;
STATSIG_ANONYMOUS_IP_ADDRESS_0 = '0.0.0.0';
Companion_instance_2 = new Companion_2();
//endregion
//region block: exports
defineProp(ClientSideFeatureManagementConfig, 'Companion', Companion_getInstance_1);
ClientSideFeatureManagementConfig.DebounceConfig = DebounceConfig;
defineProp(ClientSideFeatureManagementConfig.DebounceConfig, 'Companion', Companion_getInstance_0);
Environment.values = values;
Environment.valueOf = valueOf;
defineProp(Environment, 'PRODUCTION', Environment_PRODUCTION_getInstance);
defineProp(Environment, 'DEVELOPMENT', Environment_DEVELOPMENT_getInstance);
ExperimentParameterFetchResult.BucketedResult = BucketedResult;
ExperimentParameterFetchResult.UnbucketedResult = UnbucketedResult;
CustomIdType.values = values_0;
CustomIdType.valueOf = valueOf_0;
defineProp(CustomIdType, 'ANONYMOUS_USER_ID', CustomIdType_ANONYMOUS_USER_ID_getInstance);
defineProp(CustomIdType, 'OFFER_ID', CustomIdType_OFFER_ID_getInstance);
defineProp(CustomIdType, 'POSTER_ID', CustomIdType_POSTER_ID_getInstance);
defineProp(CustomIdType, 'TASKER_ID', CustomIdType_TASKER_ID_getInstance);
defineProp(CustomIdType, 'TASK_ULID', CustomIdType_TASK_ULID_getInstance);
defineProp(CustomIdType, 'Companion', Companion_getInstance_2);
CustomProperty.values = values_1;
CustomProperty.valueOf = valueOf_1;
defineProp(CustomProperty, 'REQUESTING_PLATFORM', CustomProperty_REQUESTING_PLATFORM_getInstance);
defineProp(CustomProperty, 'AIRTASKER_REGION_CODE', CustomProperty_AIRTASKER_REGION_CODE_getInstance);
Platform.values = values_2;
Platform.valueOf = valueOf_2;
defineProp(Platform, 'ANDROID', Platform_ANDROID_getInstance);
defineProp(Platform, 'BACKEND', Platform_BACKEND_getInstance);
defineProp(Platform, 'IOS', Platform_IOS_getInstance);
defineProp(Platform, 'WEB', Platform_WEB_getInstance);
var STATSIG_ANONYMOUS_EMAIL_ADDRESS = {get: get_STATSIG_ANONYMOUS_EMAIL_ADDRESS};
var STATSIG_ANONYMOUS_IP_ADDRESS = {get: get_STATSIG_ANONYMOUS_IP_ADDRESS};
ServerSideFeatureManagementConfig.DebounceConfig = DebounceConfig_0;
defineProp(ServerSideFeatureManagementConfig.DebounceConfig, 'Companion', Companion_getInstance_3);
export {
  ClientSideFeatureManagementConfig as ClientSideFeatureManagementConfig,
  Environment as Environment,
  Experiment as Experiment,
  ExperimentParameter as ExperimentParameter,
  ExperimentParameterFetchResult as ExperimentParameterFetchResult,
  SimpleNamedFeature as SimpleNamedFeature,
  CustomIdType as CustomIdType,
  CustomProperty as CustomProperty,
  Platform as Platform,
  User as User,
  AuthenticatedUser as AuthenticatedUser,
  AnonymousUser as AnonymousUser,
  STATSIG_ANONYMOUS_EMAIL_ADDRESS as STATSIG_ANONYMOUS_EMAIL_ADDRESS,
  STATSIG_ANONYMOUS_IP_ADDRESS as STATSIG_ANONYMOUS_IP_ADDRESS,
  toStatsigTierName as toStatsigTierName,
  getStatsigCustomProperties as getStatsigCustomProperties,
  getStatsigCustomUnitIds as getStatsigCustomUnitIds,
  ServerSideFeatureManagementConfig as ServerSideFeatureManagementConfig,
  JsClientSideAnalyticsEventFirerAdapter as JsClientSideAnalyticsEventFirerAdapter,
  JsClientPlatformSpecificConfig as JsClientPlatformSpecificConfig,
  getClientSidePlatformFeatureManagement as getClientSidePlatformFeatureManagement,
  JsServerSideAnalyticsEventFirerAdapter as JsServerSideAnalyticsEventFirerAdapter,
  JsServerPlatformSpecificConfig as JsServerPlatformSpecificConfig,
  getServerSidePlatformFeatureManagement as getServerSidePlatformFeatureManagement,
  JsClientSideStatsigSdkWrapperAdapter as JsClientSideStatsigSdkWrapperAdapter,
  JsServerSideStatsigSdkWrapperAdapter as JsServerSideStatsigSdkWrapperAdapter,
};
//endregion

//# sourceMappingURL=airtasker-kmp-feature-management-js.mjs.map
